/**
 * Módulo: Prospectiva — la visión a FUTURO del negocio del seller.
 * Los dashboards clásicos miran el retrovisor (qué pasó); Prospectiva mira el
 * parabrisas: qué viene y qué hacer ahora. Multi-canal por diseño (la compra
 * se planifica por producto, no por canal).
 *
 * V1 (plan docs/PLAN_prospectiva-planificacion-compras.md, 3-ago-2026):
 * Planificación de Compras — cruza estacionalidad de mercado (cascada
 * mercado→seller con dial de Confianza) × ventas/stock propios ×
 * tiempoReposicionDias de la ficha. SIN tareas ni automatizaciones (decisión
 * 7: la accionSugerida viaja dormida en el doc).
 *
 * No tiene rutas ni sidebar propios: vive como PRIMERA solapa del grupo
 * Dashboards de la ficha de empresa (tabsEmpresa.js). El gating real es
 * server-side: flag canary `feature.prospectiva.planCompras` por empresa
 * (callable) + rules de dashboardRollups por empresaId (lectura).
 */
export default {
  id: 'prospectiva',
  nombre: 'Prospectiva',
  descripcion: 'Visión a futuro: planificación de compras según estacionalidad, con dial de confianza',
  icono: 'trending-up',
  tipo: 'estrategia',
  version: '0.1.0',
  routes: [],
  menuItems: [],
  features: ['prospectiva-plan-compras'],
  permisoModulos: [],
}
